import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class TwoFactorRecoveryVerifyForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderVerifying = () => {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      });
    };
    this.renderGenericFail = () => {
      const {
        onRestart
      } = this.props;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: I18n.text(`login.twoFactor.recoveryVerify.verifyError.generic`)
        }), /*#__PURE__*/_jsx(Button, {
          block: true,
          use: "primary",
          onClick: onRestart,
          children: I18n.text('login.twoFactor.recoveryVerify.verifyError.restartButton')
        })]
      });
    };
    this.renderExpiredFail = () => {
      const {
        onResendRecoveryEmail
      } = this.props;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: I18n.text(`login.twoFactor.recoveryVerify.verifyError.expired`)
        }), /*#__PURE__*/_jsx(Button, {
          block: true,
          use: "primary",
          onClick: onResendRecoveryEmail,
          children: I18n.text('login.twoFactor.recoverySupport.form.recoverButton')
        }), this.renderEmailAlerts()]
      });
    };
    this.renderEmailAttemptedWarning = () => {
      const {
        emailedSupport,
        emailSupportAttempted
      } = this.props;
      if (emailSupportAttempted && !emailedSupport) {
        return /*#__PURE__*/_jsx(Alert, {
          type: "danger",
          children: I18n.text('login.twoFactor.recoveryVerify.sendErrorText')
        });
      }
      return null;
    };
    this.renderEmailSuccess = () => {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.twoFactor.recoveryVerify.emailResent"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoverySupport.success.questions"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoverySupport.success.submitted"
          })
        })]
      });
    };
    this.renderEmailAlerts = () => {
      const {
        isRecoveryEmailInErrorState,
        recoveryNeedsSupport
      } = this.props;
      if (!isRecoveryEmailInErrorState) {
        return null;
      }
      if (recoveryNeedsSupport) {
        return /*#__PURE__*/_jsx(Alert, {
          type: "danger",
          children: I18n.text('login.twoFactor.recovery.error.needsSupport')
        });
      }
      return /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: I18n.text('login.twoFactor.recovery.error.errorText')
      });
    };
    this.renderEmailSupport = () => {
      const {
        emailedSupport,
        emailSupportAttempted,
        formCompanyAndDomain,
        formLastLoginWhen,
        formLastLoginWhere,
        formPhoneNumber,
        formSubmittable,
        formUsualLoginHow,
        formUsualLoginWhere,
        isEmailingSupport,
        onFormCompanyAndDomainChange,
        onFormLastLoginWhereChange,
        onFormLastLoginWhenChange,
        onFormPhoneNumberChange,
        onFormUsualLoginHowChange,
        onFormUsualLoginWhereChange,
        onSubmit
      } = this.props;
      const disabledFormControl = isEmailingSupport || emailedSupport;
      const disabledButton = !formSubmittable || emailedSupport;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.twoFactor.recoveryVerify.description"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: I18n.text('login.twoFactor.recoveryVerify.descriptionMore')
        }), /*#__PURE__*/_jsxs(Form, {
          id: "hs-login",
          onSubmit: onSubmit,
          children: [/*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('login.twoFactor.recoveryVerify.labels.phoneNumber'),
            children: /*#__PURE__*/_jsx(PhoneNumberInput, {
              countrySelectProps: {
                disabled: disabledFormControl
              },
              extensionInputProps: {
                disabled: disabledFormControl
              }
              // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
              ,
              extensionValue: formPhoneNumber.extension,
              onChange: phoneNumber => onFormPhoneNumberChange(phoneNumber),
              phoneInputProps: {
                disabled: disabledFormControl
              }
              // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
              ,
              value: formPhoneNumber.phoneNumber
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('login.twoFactor.recoveryVerify.labels.lastLoginWhere'),
            children: /*#__PURE__*/_jsx(TextInput, {
              disabled: disabledFormControl,
              onChange: event => onFormLastLoginWhereChange(event.target.value),
              value: formLastLoginWhere
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('login.twoFactor.recoveryVerify.labels.lastLoginWhen'),
            children: /*#__PURE__*/_jsx(TextInput, {
              disabled: disabledFormControl,
              onChange: event => onFormLastLoginWhenChange(event.target.value),
              value: formLastLoginWhen
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('login.twoFactor.recoveryVerify.labels.usualLoginWhere'),
            children: /*#__PURE__*/_jsx(TextInput, {
              disabled: disabledFormControl,
              onChange: event => onFormUsualLoginWhereChange(event.target.value),
              value: formUsualLoginWhere
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('login.twoFactor.recoveryVerify.labels.usualLoginHow'),
            children: /*#__PURE__*/_jsx(TextInput, {
              disabled: disabledFormControl,
              onChange: event => onFormUsualLoginHowChange(event.target.value),
              value: formUsualLoginHow
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('login.twoFactor.recoveryVerify.labels.companyAndDomain'),
            children: /*#__PURE__*/_jsx(TextInput, {
              disabled: disabledFormControl,
              onChange: event => onFormCompanyAndDomainChange(event.target.value),
              value: formCompanyAndDomain
            })
          }), this.renderEmailAttemptedWarning(), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(LoadingButton, {
            block: true,
            use: "primary",
            type: "submit",
            disabled: disabledButton,
            resultIcon: !emailSupportAttempted || emailedSupport ? SuccessIcon : RemoveIcon,
            loading: isEmailingSupport,
            children: I18n.text('login.twoFactor.recoveryVerify.recoverButton')
          })]
        })]
      });
    };
    this.renderSuccess = () => {
      return /*#__PURE__*/_jsx("p", {
        children: I18n.text('login.twoFactor.recoveryVerify.successText')
      });
    };
  }
  render() {
    const {
      emailedSupport,
      emailSupportAttempted,
      emailSupportExpired,
      recoveryAttempted,
      recoverySent,
      verificationAttempted,
      verificationExpired,
      verified
    } = this.props;
    let renderCall;
    if (!verificationAttempted) {
      renderCall = this.renderVerifying;
    } else if (recoveryAttempted && recoverySent) {
      renderCall = this.renderEmailSuccess;
    } else if (verificationExpired) {
      renderCall = this.renderExpiredFail;
    } else if (!verified) {
      renderCall = this.renderGenericFail;
    } else if (emailSupportAttempted && emailSupportExpired) {
      renderCall = this.renderExpiredFail;
    } else if (!emailedSupport) {
      renderCall = this.renderEmailSupport;
    } else {
      renderCall = this.renderSuccess;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        as: "h1",
        children: I18n.text('login.twoFactor.recoveryVerify.header')
      }), renderCall()]
    });
  }
}
TwoFactorRecoveryVerifyForm.propTypes = {
  emailedSupport: PropTypes.bool.isRequired,
  emailSupportAttempted: PropTypes.bool.isRequired,
  emailSupportExpired: PropTypes.bool.isRequired,
  formCompanyAndDomain: PropTypes.string,
  formLastLoginWhen: PropTypes.string,
  formLastLoginWhere: PropTypes.string,
  formPhoneNumber: PropTypes.shape({
    extension: PropTypes.string,
    phoneNumber: PropTypes.string
  }),
  formSubmittable: PropTypes.bool.isRequired,
  formUsualLoginHow: PropTypes.string,
  formUsualLoginWhere: PropTypes.string,
  isEmailingSupport: PropTypes.bool.isRequired,
  onFormCompanyAndDomainChange: PropTypes.func.isRequired,
  onFormLastLoginWhereChange: PropTypes.func.isRequired,
  onFormLastLoginWhenChange: PropTypes.func.isRequired,
  onFormPhoneNumberChange: PropTypes.func.isRequired,
  onFormUsualLoginHowChange: PropTypes.func.isRequired,
  onFormUsualLoginWhereChange: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResendRecoveryEmail: PropTypes.func.isRequired,
  verificationAttempted: PropTypes.bool.isRequired,
  verificationExpired: PropTypes.bool.isRequired,
  verified: PropTypes.bool.isRequired,
  recoveryNeedsSupport: PropTypes.bool.isRequired,
  isRecoveryEmailInErrorState: PropTypes.bool.isRequired,
  recoveryAttempted: PropTypes.bool.isRequired,
  recoverySent: PropTypes.bool.isRequired
};